import { render, staticRenderFns } from "./StudentMange.vue?vue&type=template&id=0ce163b1&scoped=true&"
import script from "./StudentMange.vue?vue&type=script&lang=js&"
export * from "./StudentMange.vue?vue&type=script&lang=js&"
import style0 from "./StudentMange.vue?vue&type=style&index=0&id=0ce163b1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce163b1",
  null
  
)

export default component.exports